module.exports = "/_next/static/images/1b170209f1dd089071743dc4bb0f8158-cards.svg.webp";